export enum ActivityTool {
  CALCULATOR,
  PROTRACTOR,
  RULER,
  VIDEO,
}
